<template>
  <div class="mod-home">
    <el-card class="box-card">
  
  <div class="item">
        <b class="cardtitle">各车间产值完成一览表</b>
    <el-row :gutter="22">
  <el-col :span="24">
    <!-- :header-cell-style="{textAlign: 'center'}"
    :cell-style="{ textAlign: 'center' }"
 -->
  <el-table :data="tableData" border style="width: 100%" :header-cell-style="{textAlign: 'center'}">
      <el-table-column prop="date" label="车间" width="180"> </el-table-column>
      <el-table-column prop="name" label="本年度累计产值（万元）"> </el-table-column>
      <el-table-column prop="address" label="本月计划产值（万元）"> </el-table-column>
      <el-table-column prop="address" label="本月完成产值（万元）"> </el-table-column>
      <el-table-column prop="address" label="产值完成率（万元）"> </el-table-column>
    </el-table>
  </el-col>

</el-row>
  </div>
</el-card>

      <el-card class="box-card">
  
  <div class="item">
        <!-- <b class="cardtitle">PC车间产值一览表</b> -->
    <el-row :gutter="22">

   <el-col :span="24">

  <outputecharts :regBaseMom="regBaseMom"/>
  </el-col>
</el-row>
  </div>
</el-card>

  </div>
</template>

<script>
import outputecharts from './output/output.vue'
export default {
  components:{
    outputecharts
  },
  data() {
    return {
    regBaseMom: { date: ['1月','2月','3月','4月'], vcont: [50,20,10,80], total: [150,120,110,180] },
   tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }]
    };
  },
  created() {},
  methods: {},
};
</script>

<style>
.mod-home {
  line-height: 1.5;
}

.box-card{margin-bottom: 20px;}
</style>

